import {
    URL_ACTUALIZAR_INFORMACION_COMPANIA,
    URL_OBTENER_COMPANIA
} from "../Utils/constant.js";

import { buscar } from "../../../Commons/Scripts/Utils/Buscar";

export const obtenerCompania = (where) => {
    const url = URL_OBTENER_COMPANIA;
    return buscar(url, where);
}
export const actualizarInformacionCompania = (compania) => {
    const url = URL_ACTUALIZAR_INFORMACION_COMPANIA;
    return buscar(url, compania);
}